<template>
	<div class="flex flex-col gap-6">
		<div class="flex gap-12 pt-8">
			<div class="flex justify-center items-center sm:pt-4 pb-4 sm:pb-10">
				<AtomAnimationCheckmark />
			</div>
			<AtomTitle
				tag="h2"
				size="lg"
				class="text-gray-900"
			>
				<span class="block text-title-size-3xl">Bedankt {{ firstName }}!</span>
				<span class="text-gray-700">
					Je aanvraag is succesvol verzonden!
				</span>
			</AtomTitle>
		</div>
		<div class="flex flex-col gap-4 text-paragraph-size-md mb-8">
			<p>
				Binnen enkele minuten ontvang je de informatie per mail. Check ook even je spammap, voor het geval de mail daar terechtkomt.
			</p>
			<p>
				Mocht je zelf in de tussentijd nog vragen hebben, neem dan gerust contact met ons op via
				<a
					:href="`mailto:${generalMail}`"
					class="underline decoration-dotted underline-offset-4 hover:text-purple-500"
				>
					{{ generalMail }}
				</a> of telefonisch op
				<a
					:href="`tel:${phoneNumber}`"
					class="underline decoration-dotted underline-offset-4 hover:text-purple-500"
				>
					{{ phoneNumber }}
				</a>
				.
			</p>
		</div>
		<div class="flex items-center justify-between gap-8 pb-4">
			<AtomTitle
				size="md"
				tag="h3"
			>
				Alvast meer te weten komen? Check onze socials!
			</AtomTitle>
			<AtomSocialButtons
				:facebook="facebookPageUrl"
				:instagram="instagramPageUrl"
			/>
		</div>
	</div>
</template>

<script setup lang="ts">
import { facebookPageUrl, instagramPageUrl } from '#fit/core/consts/socialMediaPages';
import { generalMail } from '#fit/core/consts/companyData';
import { phoneNumber } from '#base/core/consts/companyData';

defineProps<{
	firstName?: string;
	lastName?: string;
	email?: string;
}>();
</script>
